<template>
  <component
    :is="mode"
    v-if="element.options!== null && element.options.attrs!==null && show "
    ref="deSelect"
    v-model="value2"
    :class-id="'visual-' + element.id + '-' + inDraw + '-' + inScreen"
    :collapse-tags="showNumber"
    :multiple="element.options.attrs.multiple"
    :placeholder="$t(element.options.attrs.placeholder) + placeholderSuffix"
    :popper-append-to-body="inScreen"
    :size="size"
    :filterable="true"
    :filter-method="filterMethod"
    :key-word="keyWord"
    popper-class="coustom-de-select"
    :list="data"
    @resetKeyWords="filterMethod"
    :custom-style="customStyle"
    @change="changeValue"
    @focus="setOptionWidth"
    @blur="onBlur"
    @visual-change="visualChange"
    @handleShowNumber="handleShowNumber"
  >
    <el-option
      v-for="item in templateData || data"
      :key="item[element.options.attrs.key]"
      :style="{width:selectOptionWidth}"
      :label="item[element.options.attrs.label]"
      :value="item[element.options.attrs.value]"
    >
      <span
        :title="item[element.options.attrs.label]"
        style="display:inline-block;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"
      >{{ item[element.options.attrs.label] }}</span>
    </el-option>
  </component>

</template>

<script>
import ElVisualSelect from '@/components/elVisualSelect'
import { linkMultFieldValues, multFieldValues } from '@/api/dataset/dataset'
import bus from '@/utils/bus'
import { isSameVueObj, mergeCustomSortOption,getStrByLang } from '@/utils'
import { getLinkToken, getToken } from '@/utils/auth'
import customInput from '@/components/widget/deWidget/customInput'
import { textSelectWidget } from '@/components/widget/deWidget/serviceNameFn.js'
import { engineInfo } from '@/api/system/engine'
import { authAreas, authAreasNameByIds } from '@/api/user'
import _jq from 'jquery'
export default {
  components: { ElVisualSelect },
  mixins: [customInput],
  props: {
    canvasId: {
      type: String,
      required: true
    },
    element: {
      type: Object,
      default: () => {
      }
    },
    inDraw: {
      type: Boolean,
      default: false
    },
    inScreen: {
      type: Boolean,
      required: false,
      default: true
    },
    size: String,
    isRelation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showNumber: false,
      selectOptionWidth: 0,
      show: true,
      value: null,
      data: [],
      onFocus: false,
      keyWord: '',
      separator: ',',
      value2:""
    }
  },
  computed: {
    mode() {
      let result = 'el-select'
      if (this.element.options && this.element.options.attrs && this.element.options.attrs.visual) {
        result = 'el-visual-select'
      }
      return result
    },
    templateData() {
      return this.mode === 'el-visual-select' ? [] : null
    },
    operator() {
      return this.element.options.attrs.multiple ? 'in' : 'eq'
    },
    defaultValueStr() {
      console.log("defaulvaleStr=====")
      if (!this.element || !this.element.options || !this.element.options.value) return ''
      return this.element.options.value.toString()
    },
    viewIds() {
      if (!this.element || !this.element.options || !this.element.options.attrs.viewIds) return ''
      return this.element.options.attrs.viewIds.toString()
    },
    manualModify() {
      return !!this.element.options.manualModify
    },
    panelInfo() {
      return this.$store.state.panel.panelInfo
    },
    customStyle() {
      const { brColor, wordColor, innerBgColor } = this.element.style
      return { brColor, wordColor, innerBgColor }
    },
    placeholderSuffix() {
      const i18nKey = this.element.options.attrs.multiple ? 'panel.multiple_choice' : 'panel.single_choice'
      console.log("i18nkey-----------------")
      console.log(i18nKey)
      const i18nValue = this.$t(i18nKey)
      console.log(i18nKey)
      return '(' + i18nValue + ')'
    },
    isCustomSortWidget() {
      return this.element.serviceName === 'textSelectWidget'
    }
  },

  watch: {
    'viewIds': function(value, old) {
      if (typeof value === 'undefined' || value === old) return
      this.setCondition()
    },
    'defaultValueStr': function(value, old) {
      console.log("==========defaultValueStr=========")
      console.log(value,old)
      if (value === old) return
      this.value = this.fillValueDerfault()
      this.changeValue(value)
    },
    'element.options.attrs.fieldId': function(value, old) {

      console.log("element.options.attrs.fieldId")
      if (value === null || typeof value === 'undefined' || value === old) return
      this.data = []

      let method = multFieldValues
      const token = this.$store.getters.token || getToken()
      const linkToken = this.$store.getters.linkToken || getLinkToken()
      if (!token && linkToken) {
        method = linkMultFieldValues
      }
      const param = { fieldIds: this.element.options.attrs.fieldId.split(this.separator), sort: this.element.options.attrs.sort }
      if (this.panelInfo.proxy) {
        param.userId = this.panelInfo.proxy
      }
      this.element.options.attrs.fieldId &&
      this.element.options.attrs.fieldId.length > 0 &&
      method(param).then(res => {
        this.data = this.optionData(res.data)
        bus.$emit('valid-values-change', true)
      }).catch(e => {
        bus.$emit('valid-values-change', false)
      }) || (this.element.options.value = '')
    },
    'element.options.attrs.multiple': function(value, old) {
      if (typeof old === 'undefined' || value === old) return
      if (!this.inDraw) {
        this.value = value ? [] : null
        this.element.options.value = ''
      }

      this.show = false
      this.$nextTick(() => {
        this.show = true
        this.handleCoustomStyle()
      })
    },
    'element.options.attrs.sort': function(value, old) {
      if (value === null || typeof value === 'undefined' || value === old || isSameVueObj(value, old)) return
      this.show = false

      this.data = []

      let method = multFieldValues
      const token = this.$store.getters.token || getToken()
      const linkToken = this.$store.getters.linkToken || getLinkToken()
      if (!token && linkToken) {
        method = linkMultFieldValues
      }
      const param = { fieldIds: this.element.options.attrs.fieldId.split(','), sort: this.element.options.attrs.sort }
      if (this.panelInfo.proxy) {
        param.userId = this.panelInfo.proxy
      }
      this.element.options.attrs.fieldId &&
      this.element.options.attrs.fieldId.length > 0 &&
      method(param).then(res => {
        this.data = this.optionData(res.data)
        this.$nextTick(() => {
          this.show = true
          this.handleCoustomStyle()
        })
        bus.$emit('valid-values-change', true)
      }).catch(e => {
        bus.$emit('valid-values-change', false)
      }) || (this.element.options.value = '')
    }

  },
  created() {
    if (this.element && this.element.options && this.element.options.attrs) {
      this.element.options.attrs.visual = true
    }

    if (!this.element.options.attrs.sort) {
      this.element.options.attrs.sort = {}
    }
    this.initLoad()
  },

  mounted() {
    bus.$on('onScroll', this.onScroll)
    if (this.inDraw) {
      bus.$on('reset-default-value', this.resetDefaultValue)
    }
    console.log("ddddddddddddddddddddd")
    //_jq("#componentf2df5350-3e3e-11ed-a0ef-6533c7acb8fb").trigger("click");;
   // this.$refs.deSelect.$refs.visualSelect.onclick();
    if(this.element.id=='f2df5350-3e3e-11ed-a0ef-6533c7acb8fb'){
      let chanagevalue1=localStorage.getItem("changevalue1");
      if(chanagevalue1!="" && chanagevalue1!=null && chanagevalue1!=0){
       // this.element.options.value=chanagevalue1
      }
    }
    // console.log(this.element.id)
    //  console.log(this)
    if(this.element.id=='c8a78dad-8608-49ff-9a84-b73610236f2c'){
      let chanagevalue=localStorage.getItem("changevalue");
      if(chanagevalue!="" && chanagevalue!=null && chanagevalue!=0){

       // this.element.options.value=chanagevalue
        // this.visualChange(chanagevalue)
        // this.changeValue(this.value)
      }
    }


    if (this.element.options.value) {
      console.log("dieeeeeeeeeeeeekd")
      this.value = this.fillValueDerfault()
      this.value2 = getStrByLang(this.value)
      //this.changeValue(this.value)
      const param = this.getCondition()
      console.log("============setCondition=============")
      console.log(this.element)
      this.element.filters= param
      //更新视图
      !this.isRelation && this.inDraw && this.$store.commit('addViewFilter', param)

      this.$nextTick(() => {
        console.log("tick-----------------")
        console.log(this.element.options.attrs.multiple)
        if (!this.element.options.attrs.multiple) {
          return
        }
       // this.handleElTagStyle()
      })
      console.log(this.value)


    }


  },
  beforeDestroy() {
    bus.$off('onScroll', this.onScroll)
    bus.$off('reset-default-value', this.resetDefaultValue)
  },
  methods: {
    //下拉过滤器切换枚举字段后没有清空默认值
    clearDefault(optionList) {
      const emptyOption = !optionList?.length

      if (!this.inDraw && this.element.options.value) {
        if (Array.isArray(this.element.options.value)) {
          if (emptyOption) {
            this.element.options.value = []
            return
          }
          const tempValueArray = JSON.parse(JSON.stringify(this.element.options.value))
          this.element.options.value = tempValueArray.filter(item => optionList.some(option => option === item))
        } else {
          if (emptyOption) {
            this.element.options.value = ''
            return
          }
          const tempValueArray = JSON.parse(JSON.stringify(this.element.options.value.split(this.separator)))
          this.element.options.value = tempValueArray.filter(item => optionList.some(option => option === item)).join(this.separator)
        }
      }

      console.log("options-------------")
      console.log(this.element.options.value)
    },
    clearHandler() {
      this.value = this.element.options.attrs.multiple ? [] : null
      this.$refs.deSelect && this.$refs.deSelect.resetSelectAll && this.$refs.deSelect.resetSelectAll()
    },
    filterMethod(key) {
      this.keyWord = key
    },
    onScroll() {

      if (this.onFocus) {
        this.$refs.deSelect.$refs.visualSelect.blur()
      }
    },
    resetDefaultValue(id) {

      console.log("resetDefaultValue==========")
      console.log(id)

      if (this.inDraw && this.manualModify && this.element.id === id) {
        this.value = this.fillValueDerfault()
        this.changeValue(this.value)
      }
    },
    onBlur() {
      this.onFocus = false
      return false
    },
    handleElTagStyle() {
      setTimeout(() => {
        this.$refs['deSelect'] && this.$refs['deSelect'].$el && textSelectWidget(this.$refs['deSelect'].$el, this.element.style)
      }, 500)
    },
    initLoad() {
      this.value = this.fillValueDerfault()
      this.initOptions()



      if (this.element.options.value) {
        this.value = this.fillValueDerfault()
        this.value2 = getStrByLang(this.value)
        this.changeValue(this.value)
        this.visualChange(this.value)
      }

    },
    refreshLoad() {
      this.initOptions()
    },
    initOptions() {
      if (this.element.options.attrs.fieldId) {
        let method = multFieldValues
        const token = this.$store.getters.token || getToken()
        const linkToken = this.$store.getters.linkToken || getLinkToken()
        if (!token && linkToken) {
          method = linkMultFieldValues
        }
        this.data = []
        method({
          fieldIds: this.element.options.attrs.fieldId.split(this.separator),
          sort: this.element.options.attrs.sort
        }).then(res => {

          this.data = this.optionData(res.data)
          this.clearDefault(this.data)

          let fieldIds=this.element.options.attrs.fieldId.split(',')
          console.log("fieldIds-----")
          console.log(fieldIds)

          console.log("------------------------this.dta--------")
          console.log(this.data)

          bus.$emit('valid-values-change', true)
        }).catch(e => {
          bus.$emit('valid-values-change', false)
        })
      }
    },
    visualChange(value) {
      this.value = value
      this.$nextTick(() => {
        console.log("tick-----------------")
        console.log(this.element.options.attrs.multiple)
        if (!this.element.options.attrs.multiple) {
          return
        }
        this.handleElTagStyle()
      })
    },
    changeValue(value) {

      let fieldIds=this.element.options.attrs.fieldId.split(',')
      console.log(this.element.options.attrs.fieldId)
      if((fieldIds.indexOf('c8a78dad-8608-49ff-9a84-b73610236f2c')!==-1)){
        localStorage.setItem("changevalue",value)
       /* if(value=="~`~`7 HQTS集团`~`8 HQTS GROUP`~`~"){
          this.value=null;
          this.element.options.value = ''
          this.element.options.manualModify = false
        }else{
          if (!this.inDraw) {
            if (value === null) {
              this.element.options.value = ''
            } else {
              this.element.options.value = Array.isArray(value) ? value.join(this.separator) : value
            }
            this.element.options.manualModify = false
          } else {
            this.element.options.manualModify = true
          }
        }*/
      }

      let line_arr=['~`~`7 消费品`~`8 Consumer Goods Line`~`~', '~`~`7 战略咨询事业群`~`8 Strategic Consultancy Business Group `~`~', '~`~`7 工业品`~`8 Industrial Product Line`~`~', 'N/A', '~`~`7 测试线`~`8 Testing Line `~`~'];
      if((fieldIds.indexOf('dd9dd1a8-2385-48f8-aaa1-db40607f2bd1')!==-1)){
        localStorage.setItem("changevalue1",value)
        if(Array.isArray(value)){
          for (const item of value) {
            if(line_arr.includes(item)){
              return location.href="/#/preview/ae83a20d-d28c-11ed-9df3-09ecbf5450a3";
            }
          }
        }else{
          if(line_arr.includes(value)){
            return location.href="/#/preview/ae83a20d-d28c-11ed-9df3-09ecbf5450a3";
          }
        }
      }

      if(fieldIds.indexOf('3cc5c0e4-ea15-47e3-990e-1ed037c8d25f')!==-1){
           localStorage.setItem("changevalue3",value)
      }


      this.setCondition()
      this.handleShowNumber()
    },

    changeValueInit(value) {
      if (!this.inDraw) {
        if (value === null) {
          this.element.options.value = ''
        } else {
          this.element.options.value = Array.isArray(value) ? value.join() : value
        }
        this.element.options.manualModify = false
      } else {
        this.element.options.manualModify = true
      }
      this.setCondition()
      this.handleShowNumber()
    },
    handleShowNumber() {
      this.showNumber = false


      this.$nextTick(() => {

        if (!this.$refs.deSelect || !this.$refs.deSelect.$refs.visualSelect || !this.$refs.deSelect.$refs.visualSelect.$refs.tags) return
        const tags = this.$refs.deSelect.$refs.visualSelect.$refs.tags
        if (!this.element.options.attrs.multiple || !this.$refs.deSelect || !tags) {
          return
        }
        const kids = tags.children[0].children
        let contentWidth = 0
        kids.forEach(kid => {
          contentWidth += kid.offsetWidth
        })
        this.showNumber = contentWidth > ((tags.clientWidth - 30) * 0.9)
        this.handleElTagStyle()
      })
    },
    getCondition() {
      const param = {
        canvasId: this.canvasId,
        component: this.element,
        value: this.formatFilterValue(),
        operator: this.operator
      }
      console.log("param-------")
      console.log(param)
      return param
    },
    setCondition() {
      const param = this.getCondition()
      console.log("============setCondition=============")
      console.log(this.element)
      //更新视图
      !this.isRelation && this.inDraw && this.$store.commit('addViewFilter', param)
      console.log(this.element)
    },
    formatFilterValue() {
      if (this.value === null) return []
      if (Array.isArray(this.value)) return this.value
      if (!this.element.options.attrs.multiple) {
        return [this.value]
      }
      return this.value.split(',')
    },
    fillValueDerfault() {
      let value=this.element.options.value === null ? '' : this.element.options.value.toString();
     // let value=getStrByLang(value)
      const defaultV = value

      if (this.element.options.attrs.multiple) {
        if (defaultV === null || typeof defaultV === 'undefined' || defaultV === '' || defaultV === '[object Object]') return []
        return defaultV.split(this.separator)
      } else {
        if (defaultV === null || typeof defaultV === 'undefined' || defaultV === '' || defaultV === '[object Object]') return null
        return defaultV.split(this.separator)[0]
      }
    },
    optionData(data) {
      console.log("option------------")
      console.log(data)
      if (!data) return null

      let dataArr=[]
      //过滤当前权限
      let isMaster=localStorage.getItem("is_master");
      let is_region=localStorage.getItem("is_region");
      let ar_jgs=localStorage.getItem("ar_jgs")
      let userId=localStorage.getItem("userId")

      dataArr=data
      //分割区域，机构，业务线字段
      let fieldIds=this.element.options.attrs.fieldId.split(',')
      console.log("fieldids ------------------")
      console.log(fieldIds)

      if(userId!=1){
        let index=dataArr.indexOf("~`~`7 HQTS集团`~`8 HQTS GROUP`~`~");
        if (index !== -1) {
          dataArr.splice(index, 1);
        }

        //机构
        if(fieldIds.indexOf('c8a78dad-8608-49ff-9a84-b73610236f2c')!==-1){
          //集团
          if(isMaster=='true') {
            console.log("isMataert")
            dataArr.unshift("~`~`7 HQTS集团`~`8 HQTS GROUP`~`~");
          }else{
            //区域负责人
            if(is_region=='true'){
              authAreas(ar_jgs).then(response => {
                let rdata=response.data
                rdata.forEach(item => {
                  if(item.names){
                    dataArr.push(item.names)
                  }
                });
              });
            }else {
              let jgnames = localStorage.getItem("jgnames");
              let jgnames_arr = jgnames.split(",");
              jgnames_arr = [...new Set(jgnames_arr)];
              dataArr = jgnames_arr;
              //默认取第一个值
              if(dataArr.length>0){
                this.value=dataArr[0];
                this.value2=getStrByLang(this.value)
                this.onFocus = false
                this.changeValueInit(this.value)
              }
            }
          }


          data=dataArr
        }
        //区域
       /* else if(fieldIds.indexOf('3cc5c0e4-ea15-47e3-990e-1ed037c8d25f')!==-1){
          let dataArr=[]
          //判断是否有区域负责人
          if(is_region=='true'){
            console.log("2222222is_region2222------")

            let ar_ids=localStorage.getItem("ar_ids")
            authAreasNameByIds(ar_ids).then(response => {
              let rdata=response.data
              rdata.forEach(item => {
                if(item.names){
                  dataArr.push(item.names)
                }
              });
            });
            this.value=dataArr[0];
            this.value2=getStrByLang(this.value)
            this.onFocus = false
            this.changeValueInit(this.value)
          }else{
            this.value=""
          }
          console.log(dataArr)
          data=dataArr
        }
        //业务线
        else if(fieldIds.indexOf('dd9dd1a8-2385-48f8-aaa1-db40607f2bd1')!==-1){
          if(is_region=='true'){
            dataArr=[]
            this.value=""
          }else{
             let chanage_name=localStorage.getItem("chanage_name")
            console.log("uuuuuuuuuuuuuuu")
            console.log(chanage_name)
            if(chanage_name){
              this.value=chanage_name;
              this.value2=getStrByLang(this.value)
              this.onFocus = false
              this.changeValueInit(this.value)
            }
          }
          data=dataArr
        }*/
      }

      let tempData = data.filter(item => !!item)
      if (this.isCustomSortWidget && this.element.options.attrs?.sort?.sort === 'custom') {
        tempData = mergeCustomSortOption(this.element.options.attrs.sort.list, tempData)
      }
      return tempData.map(item => {
        let newitem=getStrByLang(item)
        return {
          id: item,
          text: newitem
        }
      })
    },
    setOptionWidth(event) {
      console.log("-------")
      console.log(event)

      this.onFocus = true
      // 下拉框弹出时，设置弹框的宽度
      this.$nextTick(() => {
        // this.selectOptionWidth = event.srcElement.offsetWidth + 'px'
        this.selectOptionWidth = event.srcElement.parentElement.parentElement.offsetWidth + 'px'
        this.handleCoustomStyle()
      })
    }

  }

}
</script>

<style lang="scss">
.coustom-de-select {
  background-color: var(--BgSelectColor, #FFFFFF) !important;
  border-color: var(--BrSelectColor, #E4E7ED) !important;
  // .popper__arrow::after{
  //   border-bottom-color: var(--BgSelectColor, #FFFFFF) !important;
  // }

  .popper__arrow,
  .popper__arrow::after {
    display: none !important;
  }

  .el-select-dropdown__item {
    color: var(--SelectColor, #606266);
  }

  .el-select-dropdown__item.selected {
    color: #409eff;
    background-color: rgb(245, 247, 250, .5);
  }

  .el-select-dropdown__item.hover {
    background-color: rgb(245, 247, 250, .5);
  }
}

.coustom-de-select.is-multiple {
  .el-select-dropdown__item.selected {
    background-color: rgb(245, 247, 250, .5) !important;
  }

  .el-select-dropdown__item.hover {
    background-color: rgb(245, 247, 250, .5) !important;
  }
}
</style>
